import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-bg-primary flex items-center justify-center p-4 overflow-hidden relative">
            {/* Animated Background Elements */}
            <div className="absolute inset-0 overflow-hidden">
                {/* Floating construction elements */}
                <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-gradient-to-br from-secondary-100 to-secondary-200 rounded-full opacity-40 blur-3xl animate-pulse" />
                <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-gradient-to-br from-tertiary-100 to-tertiary-200 rounded-full opacity-40 blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-primary-100 to-primary-200 rounded-full opacity-30 blur-3xl" />

                {/* Grid pattern */}
                <div className="absolute inset-0 opacity-5" style={{
                    backgroundImage: `
                        linear-gradient(var(--color-primary-300) 1px, transparent 1px),
                        linear-gradient(90deg, var(--color-primary-300) 1px, transparent 1px)
                    `,
                    backgroundSize: '40px 40px'
                }} />
            </div>

            {/* Main Content */}
            <div className="relative z-10 text-center max-w-2xl mx-auto">
                {/* 404 Number with Gradient */}
                <div className="relative mb-8">
                    <h1 className="text-[180px] md:text-[220px] font-bold leading-none select-none"
                        style={{
                            background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 50%, var(--color-tertiary) 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                            textShadow: '0 4px 30px rgba(51, 65, 85, 0.2)'
                        }}>
                        404
                    </h1>

                    {/* Construction icon overlay */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-10">
                        <svg className="w-48 h-48" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2L2 7v15h20V7L12 2zm0 2.18L20 8.27V20H4V8.27L12 4.18zM11 15h2v4h-2v-4zm-3 0h2v4H8v-4zm6 0h2v4h-2v-4z" />
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
                    Sayfa Bulunamadı
                </h2>

                {/* Description */}
                <p className="text-lg text-text-secondary mb-8 max-w-md mx-auto">
                    Aradığınız sayfa mevcut değil veya taşınmış olabilir.
                    Lütfen adresi kontrol edin veya ana sayfaya dönün.
                </p>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                    {/* Primary Button - Ana Sayfa */}
                    <Link
                        to="/"
                        className="group relative inline-flex items-center gap-3 px-8 py-4 text-white font-semibold rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-xl"
                        style={{
                            background: 'linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary-dark) 100%)'
                        }}
                    >
                        {/* Shine effect */}
                        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />

                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                        <span>Ana Sayfaya Dön</span>
                    </Link>

                    {/* Secondary Button - Geri */}
                    <button
                        onClick={() => window.history.back()}
                        className="group inline-flex items-center gap-3 px-8 py-4 bg-white text-primary font-semibold rounded-xl border-2 border-primary-200 hover:border-tertiary hover:text-tertiary transition-all duration-300 hover:shadow-lg"
                    >
                        <svg className="w-5 h-5 transition-transform group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        <span>Geri Dön</span>
                    </button>
                </div>

                {/* Decorative bottom element */}
                <div className="mt-16 flex items-center justify-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-secondary animate-bounce" style={{ animationDelay: '0ms' }} />
                    <div className="w-2 h-2 rounded-full bg-tertiary animate-bounce" style={{ animationDelay: '150ms' }} />
                    <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '300ms' }} />
                </div>
            </div>
        </div>
    );
};

export default NotFound;
